/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

export const getAuthRememberMe = auth =>
  auth && auth.rememberMe ? auth.rememberMe : false;
export const getAuthMobileNumber = auth =>
  auth && auth.mobileNumber ? auth.mobileNumber : null;
export const getProfileStatus = auth =>
  auth && auth.profileStatus ? auth.profileStatus : false;
export const getAuthToken = auth => (auth && auth.token ? auth.token : null);
export const getAuthLoginLoading = state =>
  state && state.auth && state.auth.login && state.auth.login.loading
    ? state.auth.login.loading
    : false;
export const getAuthSignUpLoading = state =>
  state && state.auth && state.auth.signUp && state.auth.signUp.loading
    ? state.auth.signUp.loading
    : false;
export const getPostForgetPasswordStatus = state =>
  state &&
  state.auth &&
  state.auth.forgotPassword &&
  state.auth.forgotPassword.status
    ? state.auth.forgotPassword.status
    : false;
export const getPostForgetPasswordLoading = state =>
  state &&
  state.auth &&
  state.auth.forgotPassword &&
  state.auth.forgotPassword.loading
    ? state.auth.forgotPassword.loading
    : false;
export const getPostForgetPasswordItemToken = state =>
  state &&
  state.auth &&
  state.auth.forgotPassword &&
  state.auth.forgotPassword.item &&
  state.auth.forgotPassword.item.token
    ? state.auth.forgotPassword.item.token
    : null;
export const getPostForgetPasswordExpiryTimestamp = state => {
  return state &&
    state.auth &&
    state.auth.forgotPassword &&
    state.auth.forgotPassword.item &&
    state.auth.forgotPassword.item.expiry_datetime &&
    state.auth.forgotPassword.item.expiry_datetime.timestamp
    ? state.auth.forgotPassword.item.expiry_datetime.timestamp
    : null;
};
export const getPostResetPasswordWithPhoneStatus = state =>
  state &&
  state.auth &&
  state.auth.resetPasswordWithPhone &&
  state.auth.resetPasswordWithPhone.status
    ? state.auth.resetPasswordWithPhone.status
    : false;
export const getPostResetPasswordWithPhoneLoading = state =>
  state &&
  state.auth &&
  state.auth.resetPasswordWithPhone &&
  state.auth.resetPasswordWithPhone.loading
    ? state.auth.resetPasswordWithPhone.loading
    : false;
export const getPostResetPasswordWithPhoneItemToken = state =>
  state &&
  state.auth &&
  state.auth.resetPasswordWithPhone &&
  state.auth.resetPasswordWithPhone.item &&
  state.auth.resetPasswordWithPhone.item.token
    ? state.auth.resetPasswordWithPhone.item.token
    : null;
export const getPostResetPasswordWithEmailStatus = state =>
  state &&
  state.auth &&
  state.auth.resetPasswordWithEmail &&
  state.auth.resetPasswordWithEmail.status
    ? state.auth.resetPasswordWithEmail.status
    : false;
export const getPostResetPasswordWithEmailLoading = state =>
  state &&
  state.auth &&
  state.auth.resetPasswordWithEmail &&
  state.auth.resetPasswordWithEmail.loading
    ? state.auth.resetPasswordWithEmail.loading
    : false;



// WEBPACK FOOTER //
// ./src/selectors/auth.js